module.exports = __webpack_public_path__ + "img/title8.ffd4eb85.png";